import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/industries/IndustriesPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Badge","badgeVariants"] */ "/vercel/path0/apps/web/components/ui/adapters/Badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselItem","useCarousel"] */ "/vercel/path0/apps/web/components/ui/adapters/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/ui/adapters/LiveChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text","Heading"] */ "/vercel/path0/apps/web/components/ui/adapters/Text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider","useTheme"] */ "/vercel/path0/apps/web/components/ui/adapters/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeSwitcher"] */ "/vercel/path0/apps/web/components/ui/adapters/ThemeSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleSwitch"] */ "/vercel/path0/apps/web/components/ui/adapters/ToggleSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialog","AlertDialogAction","AlertDialogCancel","AlertDialogContent","AlertDialogDescription","AlertDialogFooter","AlertDialogHeader","AlertDialogTitle","AlertDialogTrigger"] */ "/vercel/path0/apps/web/components/ui/alert-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarFallback","AvatarImage"] */ "/vercel/path0/apps/web/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/ui/base-product-viewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuContent","DropdownMenuItem","DropdownMenuLabel","DropdownMenuSeparator","DropdownMenuTrigger"] */ "/vercel/path0/apps/web/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/apps/web/components/ui/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectTrigger","SelectValue","SelectContent","SelectItem"] */ "/vercel/path0/apps/web/components/ui/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/web/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsContent","TabsList","TabsTrigger"] */ "/vercel/path0/apps/web/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","success","error","warning","promise","dismiss"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
